import React from "react"
import { Icon } from "@/components"
import { Center, SegmentedControl } from "@mantine/core"
import { useFormContext } from "react-hook-form"
import { advocatesRequireApprovalField } from "@/pages/campaign-form/components/sections/basics/AdvancedTextSettings/MessageSettingsForm/MessageSettingsForm"

export const REWORK_WITH_AI_ACTIVE = "1"
export const REWORK_WITH_AI_INACTIVE = "0"

export const ReworkWithAIButton = () => {
    const formContext = useFormContext()

    const handleChange = (value: string) => {
        const isActivating = value === REWORK_WITH_AI_ACTIVE
        formContext.setValue("should_rework_with_ai", isActivating)

        if (isActivating) formContext.setValue(advocatesRequireApprovalField, true)
    }

    return (
        <SegmentedControl
            name="should_rework_with_ai"
            onChange={handleChange}
            value={formContext.watch("should_rework_with_ai") ? REWORK_WITH_AI_ACTIVE : REWORK_WITH_AI_INACTIVE}
            data={[
                {
                    value: REWORK_WITH_AI_ACTIVE,
                    label: (
                        <Center style={{ gap: 5 }}>
                            <Icon icon="sparkles" iconFamily="fas" size="sm" />
                            <span>Rework with AI</span>
                        </Center>
                    ),
                },
                {
                    value: REWORK_WITH_AI_INACTIVE,
                    label: <span>Regular text</span>,
                },
            ]}
        />
    )
}
